import { HttpHeaders, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { NEVER, of } from 'rxjs';
import { ATLAS_PENDING } from './debug';
import { resolveAtlasDebugResponse } from './debug-runtime';

export const atlasDebugInterceptor: HttpInterceptorFn = (request, next) => {
  const response = resolveAtlasDebugResponse({
    url: request.urlWithParams,
    method: request.method,
    body: request.body,
    pathname: new URL(request.urlWithParams, window.location.origin).pathname,
    search: new URL(request.urlWithParams, window.location.origin).search,
  });

  if (!response) {
    return next(request);
  }

  if (response === ATLAS_PENDING) {
    return NEVER;
  }

  return of(
    new HttpResponse({
      status: response.status ?? 200,
      body: response.body,
      headers: new HttpHeaders(response.headers ?? {}),
    }),
  );
};
